import { c as _c } from "react/compiler-runtime";
import React from "react";
import { motion, AnimatePresence } from "motion/react";
interface FloatingButtonAnimationProps {
  isVisible: boolean;
  children: React.ReactNode;
}

/**
 * Animation wrapper for the floating button that appears when agent is closed
 */
export const FloatingButtonAnimation: React.FC<FloatingButtonAnimationProps> = t0 => {
  const $ = _c(5);
  const {
    isVisible,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== isVisible) {
    t1 = isVisible && <motion.div initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: "easeInOut"
    }} className="fixed bottom-4 right-4 z-51">{children}</motion.div>;
    $[0] = children;
    $[1] = isVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};